import { AxiosAPI } from './AxiosApi';
class AgenciesApi extends AxiosAPI {
    fetchAgencies = async (options = {}) => {
        return this.GET(this.apiSchema.GET.agencies.agencies(), options);
    };
}
export default new AgenciesApi();
